import React from 'react';
import styled from 'styled-components';
import { themes } from '../themes';

const ThemeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
`;

const ThemeCard = styled.div<{ isSelected: boolean; theme: any }>`
  padding: 20px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
  border: 3px solid ${props => props.isSelected ? '#667eea' : 'transparent'};
  background: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
  position: relative;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }

  &::before {
    content: '';
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: ${props => props.isSelected ? '#48bb78' : 'rgba(255, 255, 255, 0.8)'};
    border: 2px solid white;
  }
`;

const ThemeName = styled.h3`
  margin: 0 0 15px 0;
  font-size: 18px;
  font-weight: 600;
`;

const ColorPalette = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 15px;
`;

const ColorSwatch = styled.div<{ color: string }>`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: ${props => props.color};
  border: 1px solid rgba(255, 255, 255, 0.3);
`;

const SampleButton = styled.button`
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  font-size: 14px;
`;

const SampleText = styled.p`
  margin: 0;
  font-size: 14px;
  opacity: 0.9;
`;

interface ThemeSelectorProps {
  selectedTheme: string;
  onThemeChange: (theme: string) => void;
}

const ThemeSelector: React.FC<ThemeSelectorProps> = ({ selectedTheme, onThemeChange }) => {
  return (
    <ThemeGrid>
      {Object.entries(themes).map(([key, theme]) => (
        <ThemeCard
          key={key}
          isSelected={selectedTheme === key}
          theme={theme}
          onClick={() => onThemeChange(key)}
        >
          <ThemeName>{theme.name}</ThemeName>
          <ColorPalette>
            <ColorSwatch color={theme.colors.primary} />
            <ColorSwatch color={theme.colors.secondary} />
            <ColorSwatch color={theme.colors.accent} />
          </ColorPalette>
          <SampleButton
            style={{
              background: theme.colors.button,
              color: theme.colors.text
            }}
          >
            Sample
          </SampleButton>
          <SampleText style={{ fontFamily: theme.fonts.body }}>
            Beautiful typography
          </SampleText>
        </ThemeCard>
      ))}
    </ThemeGrid>
  );
};

export default ThemeSelector;
